if (!customElements.get('tabbed-content')) {
  class Tabs extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector('[role="tablist"]');
      this.mobileDropdown = this.querySelector('#mobile-tabs');
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      this.activeTab = this.tabList.querySelector('[aria-selected="true"]') || this.tabs[0];

      // If no tab is active by default, activate the first tab.
      if (!this.activeTab) {
        this.activeTab = this.tabs[0];
        this.activateTab(this.activeTab);
      }

      this.addListeners();
      this.checkScreenSize();
    }

    addListeners() {
      this.tabList.addEventListener('click', this.handleClick.bind(this));
      this.mobileDropdown.addEventListener('change', this.handleMobileSelect.bind(this));
      window.addEventListener('resize', this.checkScreenSize.bind(this));
    }

    handleClick(evt) {
      if (!evt.target.matches('[role="tab"]') || evt.target === this.activeTab) return;
      this.activateTab(evt.target);
    }

    handleMobileSelect(evt) {
      const selectedPanelId = evt.target.value;
      const selectedTab = this.querySelector(`[aria-controls="${selectedPanelId}"]`);
      if (selectedTab) {
        this.activateTab(selectedTab);
      }
    }

    activateTab(tab) {
      this.deactivateActiveTab();
      Tabs.setTabState(tab, true);
      tab.removeAttribute('tabindex');
      this.activeTab = tab;

      if (document.activeElement.matches('.tablist__tab')) {
        tab.focus();
      }

      // Update mobile dropdown
      if (this.mobileDropdown) {
        this.mobileDropdown.value = tab.getAttribute('aria-controls');
      }
    }

    deactivateActiveTab() {
      Tabs.setTabState(this.activeTab, false);
      this.activeTab.setAttribute('tabindex', '-1');
      this.activeTab = null;
    }

    static setTabState(tab, active) {
      tab.setAttribute('aria-selected', active);
      const panelId = tab.getAttribute('aria-controls');
      document.getElementById(panelId).hidden = !active;
    }

    checkScreenSize() {
      if (window.innerWidth <= 768) {
        this.tabList.style.display = 'none';
        this.mobileDropdown.classList.remove('hidden');
      } else {
        this.tabList.style.display = '';
        this.mobileDropdown.classList.add('hidden');
      }
    }
  }

  customElements.define('tabbed-content', Tabs);
}